import { useMemo } from 'react';
import { motion } from 'framer-motion';

const VIEWPORT = { once: true, margin: '-60px' };
const EASE = [0.22, 1, 0.36, 1];
const VISIBLE = { opacity: 1, y: 0 };

// Simple, restrained corporate fade-up on scroll into view.
export default function Reveal({
  children,
  delay = 0,
  y = 20,
  className = '',
  as = 'div',
  ...rest
}) {
  const MotionTag = motion[as] || motion.div;
  const initial = useMemo(() => ({ opacity: 0, y }), [y]);
  const transition = useMemo(() => ({ duration: 0.6, ease: EASE, delay }), [delay, EASE]);
  return (
    <MotionTag
      initial={initial}
      whileInView={VISIBLE}
      viewport={VIEWPORT}
      transition={transition}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
